export const globalTypes = {
}

export const globalActions = {
}
